class RandomizerUtil {
  //* pass in an array will return array of n random items selected
  static getRandomItemsFromArray = (arr: any = [], n: number = 0) => {
    const result = new Array(n)
    let len = arr.length
    const taken = new Array(len)

    try {
      while (n--) {
        const x = Math.floor(Math.random() * len)
        result[n] = arr[x in taken ? taken[x] : x]
        taken[x] = --len in taken ? taken[len] : len
      }

      return result
    } catch (err) {
      console.log(`Error in getRandom range ${err}`)
      return []
    }
  }
}

export default RandomizerUtil
